const topbar = {
    docs: 'Documentos',
    help: 'Ayuda',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
